/* eslint-disable no-unused-vars */
import React, { Component } from 'react';
import { Router, Route } from 'react-router-dom';
import { createHashHistory } from 'history';
import { Provider } from 'react-redux';
import moment from 'moment-timezone';
import createStore from './redux/RootReducer';
import './App.scss';
import 'mapbox-gl/dist/mapbox-gl.css';
import NavTabBar from './components/NavTabBar/NavTabBar';
import JourneyPlanContainer from './containers/JourneyPlan/JourneyPlanContainer';
import LiveDeparturesContainer from './containers/LiveDepartures/LiveDepartureContainer';
import TimeTablesContainer from './containers/TimeTables/TimeTablesContainer';

import { init as initAnalytics } from './services/AnalyticsService';
import NavigationService, { DEFAULT_TAB, TABS } from './services/NavigationService';
import { NavigationKeys } from './utils/Keyboard';
import { IS_IE, IS_SAMSUNG_BROWSER } from './services/PlatformCheckerService';
import { removeOutdateRecentSearches } from './services/TimetablesService';

const history = createHashHistory({
  hashType: 'hashbang',
});

// The default tab is the live departures
if (!NavigationService.isValidUrl(history?.location?.pathname)) {
  history.push(DEFAULT_TAB);
}
// Listen for location change to block any URL which is not valid
const unlisten = history.listen((location) => {
  if (!NavigationService.isValidUrl(location.pathname)) {
    history.goBack();
  }
});

let wayfindingWidgetRoot;
const getWayfindingWidgetRoot = () => {
  if (!wayfindingWidgetRoot) {
    wayfindingWidgetRoot = global.document.getElementById('at-wayfinding');
  }
  return wayfindingWidgetRoot;
};

const disableAccessibilityOutlines = () => {
  getWayfindingWidgetRoot().classList.remove('wayfinding--keyboard-active');
};
const enableAccessibilityOutlines = () => {
  getWayfindingWidgetRoot().classList.add('wayfinding--keyboard-active');
};

moment.tz.setDefault('Pacific/Auckland');
const store = createStore();
initAnalytics();

class App extends Component {
  componentDidMount() {
    getWayfindingWidgetRoot().addEventListener('mousedown', this._onClick);
    getWayfindingWidgetRoot().addEventListener('keydown', this._onKeyDown);

    removeOutdateRecentSearches();
  }

  componentWillUnmount() {
    getWayfindingWidgetRoot().removeEventListener('mousedown', this._onClick);
    getWayfindingWidgetRoot().removeEventListener('keydown', this._onKeyDown);
    unlisten();
  }

  _onClick = (event) => {
    const clickCount = event.detail;
    // A click count of 0 is triggered when pressing ENTER on a button element, we do not want to do anything here in that case.
    // IE 11 and Samsung Browser will always send event with a click count of 0, they should be excluded from this rule
    if (clickCount !== 0 || IS_IE || IS_SAMSUNG_BROWSER) {
      const eventTarget = event.target;

      if (eventTarget.tagName === 'INPUT' && eventTarget.type === 'text') {
        enableAccessibilityOutlines();
      } else {
        disableAccessibilityOutlines();
      }
    }
  };

  _onKeyDown = (event) => {
    if (NavigationKeys.includes(event.keyCode)) {
      enableAccessibilityOutlines();
    }
  };

  render() {
    return (
      <Provider store={store}>
        <Router history={history}>
          <div className="App" tabIndex="-1">
            <link href="https://fonts.googleapis.com/css?family=Open+Sans:300,400,700" rel="stylesheet" />
            <NavTabBar history={history} />
            <Route path={TABS.JOURNEY_PLANNER} component={JourneyPlanContainer} />
            <Route
              path={TABS.LIVE_DEPARTURES}
              render={props => (
                <LiveDeparturesContainer {...props} enableAccessibilityOutlines={enableAccessibilityOutlines} />
              )}
            />
            <Route path={TABS.TIMETABLES} component={TimeTablesContainer} />
          </div>
        </Router>
      </Provider>
    );
  }
}

export default App;
